import { FormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { FormField } from '@domgen/dgx-fe-forms/layout';

export interface CmsPersonalDetailsForm {
  addressFieldset: FormOverrideAddressFieldset;
  emailAddressField: FormField;
  firstNameField: FormField;
  lastNameField: FormField;
  telephoneNumberField: FormField;
  titleIdField: FormField;
}
